import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {PAGE_LOADED} from "../actions/WorkforceOnePageActions";
import {mergeMap} from "rxjs/operators";
import {EMPTY, of} from "rxjs";
import {WorkforceOneLoggedInPayload, WorkforceOneUserHasLoggedIn} from "../actions/WorkforceOneLoginActions";
import {GetAuthToken, GetSSOToken, SetSSOToken} from "../storage/AuthToken";
import {GetLoginPortals} from "../storage/LogInPortals";
import {GetUserId} from "../storage/UserId";

const WorkforceOneLoginPageReturn:  Epic<AppActions, AppActions, AppState> = (action$, states$) => {
    return action$.pipe(
        ofType(PAGE_LOADED),
        mergeMap((action: AppActions) => {
                const loginToken = GetAuthToken();
                const loginId = GetUserId();
                const ssoToken = GetSSOToken();
                const portalsInformation = GetLoginPortals();
                if(loginToken && portalsInformation && portalsInformation.length > 0 && loginId){
                    const loginPayload : WorkforceOneLoggedInPayload = {
                        UserId: loginId,
                        AuthToken: loginToken,
                        Portal: {Clinic: portalsInformation},
                    };
                    return of(WorkforceOneUserHasLoggedIn(loginToken, loginId, ssoToken, loginPayload));
                }
                SetSSOToken("");
                return EMPTY;
            }
        )
    );
};
export default WorkforceOneLoginPageReturn;
